module.exports = __webpack_public_path__ + "static/media/spade.decdb3b0.svg";